<template>
  <div>
     <h4>会议主题：{{meetingInfo.meeting_subject}} ，编号：{{meetingInfo.id}}</h4>
    <el-form ref="form" :model="form" size="small" label-position="top">
      <el-table
        v-if="tableDataNew.length>2"
        ref="table"
        :data="tableDataNew"
        border
        height="700px"
        :span-method="arraySpanMethod"
        :header-cell-style="{ background: '#41A1FF', color: '#fff' }"
        :row-class-name="hiddenRow">
        <el-table-column label="评分对象" align="center">
          <template slot-scope="scope">
            <span
              v-if="[0, 2].includes(scope.$index)"
              style="fontWeight: bold"
              >{{ scope.row.name }}</span>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="一星" prop="star1">
          <template slot-scope="scope">
            <div v-if="scope.row.type==='comment'" v-html="scope.row.star1"></div>
            <div v-else>
              <div v-if="scope.row.type == 'host'">
                <div class="box" v-show="form.host.workcode !== $store.getters.username">
                  <div class="rate-box">
                    <el-rate
                      v-model="form.host.score"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      allow-half
                      :disabled="isDisabled"
                      show-score/>
                  </div>
                  <el-form-item
                    :prop="'host.comment'"
                    :rules="[
                      {
                        required: [0.5, 1, 5].includes(form.host.score) ? true : false,
                        message: '请填写评分说明',
                        trigger: 'blur',
                      },
                    ]"
                    class="form-item-box"
                    label="评分说明"
                  >
                    <el-input
                      v-model="form.host.comment"
                      size="small"
                      placeholder="请输入评分说明(0.5,1,5星必填)"
                      clearable
                      type="textarea"
                      :disabled="isDisabled"
                    />
                  </el-form-item>
                </div>
              </div>
              <div v-else-if="scope.row.type == 'attendees'">
                <div class="box">
                  <div class="rate-box">
                    <el-rate
                      v-model="form.attendees[scope.row.subscript].score"
                      :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      allow-half
                      show-score
                      :disabled="isDisabled"
                    />
                  </div>
                  <el-form-item
                    class="form-item-box"
                    label="评分说明"
                    :prop="'attendees['+ scope.row.subscript+'].comment'"
                    :rules="[
                      {
                        required: [0.5, 1, 5].includes(form.attendees[scope.row.subscript].score) ? true : false,
                        message: '请填写评分说明',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.attendees[scope.row.subscript].comment"
                      size="small"
                      placeholder="请输入评分说明(0.5,1,5星必填)"
                      clearable
                      type="textarea"
                      :disabled="isDisabled"
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二星" prop="star2"></el-table-column>
        <el-table-column label="三星" prop="star3"></el-table-column>
        <el-table-column label="四星" prop="star4"></el-table-column>
        <el-table-column label="五星" prop="star5"></el-table-column>
      </el-table>
    </el-form>
    <div style="text-align: center; padding: 10px; margin-top: 20px" v-if="tableDataNew.length>2">

      <div v-if="form.host.workcode === $store.getters.username">
        <el-button
          v-if="host_is_score === 0"
          type="success"
          style="width: 200px"
          @click="submitBtn"
          >提交</el-button
        >
        <el-button
          v-if="host_is_score === 1"
          type="info"
          style="width: 200px"
          >已提交</el-button
        >
      </div>

      <div v-else>
        <el-button
          v-if="is_score === 0"
          type="success"
          style="width: 200px"
          @click="submitBtn"
          >提交</el-button
        >
        <el-button
          v-else-if="is_score === 1"
          type="info"
          style="width: 200px"
          >已提交</el-button
        >
        <span v-else></span>
      </div>
    </div>
  </div>
</template>

<script>
import { searchScoringDimension, submitScore } from '@/api/common' // 获取维度 评分项接口
import { meetingid, attendeessearch } from '@/api/seedetails' // 根据会议id 获取会议人员  分类表等 tyoe	int	项目类型（0会议室1主持人2会议秘书3参会人）

export default {
  data() {
    return {
      form: {
        host: {
          name: '',
          workcode: '',
          score: 3,
          project: '',
          comment: ''
        },
        attendees: [
          {
            subscript: 0,
            comment: ''
          }
        ],
        target_status: 1,
        problem_status: 1,
        speak_num: 0,
        speak_time: 0
      },
      tableDataNew: [
        {
          name: '主持人',
          // titles: ["一星", "二星","三星","四星","五星"],
          type: 'comment',
          star1: '',
          star2: '',
          star3: '',
          star4: '',
          star5: '',
          setting: []
        },
        {
          name: '',
          type: 'host',
          score: 0,
          star1: '',
          star2: '',
          star3: '',
          star4: '',
          star5: ''
        },
        {
          name: '参会人',
          // titles: ["一星", "二星","三星","四星","五星"],
          type: 'comment',
          star1: '',
          star2: '',
          star3: '',
          star4: '',
          star5: '',
          setting: []
        }
      ], // 汇总
      max: 10,
      iconClasses: ['icon-rate-face-1', 'icon-rate-face-2', 'icon-rate-face-3'], // 等同于 { 2: 'icon-rate-face-1', 4: { value: 'icon-rate-face-2', excluded: true }, 5: 'icon-rate-face-3' }
      is_score: 3,
      host_is_score: 3,
      user: '', // 用户信息
      examine: 0, // 是否审核,
      meetingInfo: { meeting_subject: '' }
    }
  },
  created() {
    this.getMetting()
  },
  computed: {
    isDisabled() {
      if (this.form.host.workcode === this.$store.getters.username) {
        return this.host_is_score === 1
      } else {
        return this.is_score === 1
      }
    }
  },
  methods: {
    getMetting() {
      // 该会议数据
      meetingid(this.$route.query.id).then((res) => {
        this.meetingInfo = { ...res.data.meeting }
        const data = { ...res.data.meeting }
        this.form.host = {
          name: data.host.name,
          workcode: data.host.workcode,
          score: 3,
          project: '',
          comment: ''
        }
        this.form.meeting_id = data.id
      }).then(() => {
        this.getAttend()
      })
    },
    getAttend() {
      attendeessearch({
        meeting_id: this.$route.query.id,
        group: 'all',
        page: 1,
        page_size: 1000
      })
        .then((res) => {
          const data = res.data.attendees
          if (res) {
            const attendees = []
            for (const i in data) {
              const element = data[i]
              if (element.workcode === this.$store.getters.username) {
                if (element.workcode === this.form.host.workcode) {
                  this.host_is_score = element.is_score
                } else {
                  this.is_score = element.is_score // 0未审核 1已审核  已就不能提交了 工号相同可能是 参会人或会议秘书
                }
              } else {
                if (this.form.host.workcode !== element.workcode && element.u_status === 1 && element.role === 'attendees') {
                  attendees.push({
                    name: element.name,
                    workcode: element.workcode,
                    score: Number(element.gave_score),
                    project: '',
                    comment: ''
                  })
                }
              }
            }
            // 如果是主持人，且未评分，则默认参会人评分三颗星 / 或者非主持人，且未评分
            if ((this.form.host.workcode === this.$store.getters.username && this.host_is_score === 0) || (this.form.host.workcode !== this.$store.getters.username && this.is_score === 0)) {
              attendees.forEach(item => {
                item.score = 3
              })
            }
            this.form.attendees = attendees
          }
        })
        .then(() => {
          this.getHostItem() //
          this.getAttendeesItem() // 给每个人加上维度id
        })
    },
    getHostItem() {
      // 0主持人评分项 维度
      const params = {
        type: 1,
        page_size: 100 // 100个项应该够了
      }
      searchScoringDimension(params).then((res) => {
        const data = res.data.settings
        if (data.length) {
          // 加每个人评分的对应每个评分值
          this.form.host.project = data[0].id
          // 改版一星二星 获取主持人配置 分割字符串成数组 展示在表头和第一行
          const titles = []
          const setting = []
          const settingData = data[0].name.split('；')
          settingData.map((item) => {
            titles.push(item.split('：')[0])
            setting.push(item.replaceAll('\n', '').split('：')[1])
          })

          // this.tableDataNew[0].titles = titles;
          this.tableDataNew[0].setting = setting
          this.tableDataNew[0].star1 = setting[0] || '-'
          this.tableDataNew[0].star2 = setting[1] || '-'
          this.tableDataNew[0].star3 = setting[2] || '-'
          this.tableDataNew[0].star4 = setting[3] || '-'
          this.tableDataNew[0].star5 = setting[4] || '-'
          this.tableDataNew[1].name = this.form.host.name
          // 改版一星二星 获取主持人配置 分割字符串成数组 展示在表头和第一行
          this.$refs.table.doLayout() // 解决表格错乱
        }
      })
    },

    getAttendeesItem() {
      // 参会者评分项 维度
      const params = {
        type: 3,
        page_size: 100 // 100个项应该够了
      }
      searchScoringDimension(params).then((res) => {
        const data = res.data.settings
        if (data.length) {
          this.attendeesItems = data
          // 加每个人评分的对应每个评分值
          this.form.attendees.forEach((element, index) => {
            element.project = data[0].id
            this.tableDataNew.push({
              name: element.name,
              type: 'attendees',
              subscript: index, // 下标
              start1: '',
              star2: '',
              star3: '',
              star4: '',
              star5: ''
            })
          })

          // 改版一星二星
          const titles = []
          const setting = []
          const settingData = this.attendeesItems[0].name.split('；')
          settingData.map((item) => {
            titles.push(item.split('：')[0])
            setting.push(item.replaceAll('\n', '').split('：')[1])
          })

          // this.tableDataNew[2].titles = titles;
          this.tableDataNew[2].setting = setting
          this.tableDataNew[2].star1 = setting[0] || '-'
          this.tableDataNew[2].star2 = setting[1] || '-'
          this.tableDataNew[2].star3 = setting[2] || '-'
          this.tableDataNew[2].star4 = setting[3] || '-'
          this.tableDataNew[2].star5 = setting[4] || '-'
          // 改版一星二星
          this.$refs.table.doLayout() // 解决表格错乱
        } else {
          this.attendeesItems = []
        }
      })
    },
    hiddenRow({ row, rowIndex }) {
      if (rowIndex === 0 || rowIndex === 2) {

      } else {
        return 'hiddenRow'
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.type && (row.type === 'host' || row.type === 'attendees')) {
        console.log(row.type, row)
        if (columnIndex === 0) {
          return [1, 1]
        }
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 5
          }
        } else {
          return [0, 0]
        }
      }
    },
    setTableData(item, id, value) {
      this.$set(item, id, value)
    },
    submitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          submitScore(this.form).then((res) => {
            if (res.code === 'success') {
              this.is_score = 1
              this.host_is_score = 1
              this.$message({
                type: 'success',
                message: '评分成功!'
              })
              this.$router.push({ name: 'conferenceStatus' })
            } else {
              this.$message({
                type: 'error',
                message: '评分失败!'
              })
            }
          }).catch((err) => {
            this.$message({
              type: 'error',
              message: '接口调用出现问题!'
            })
          })
        } else {
          alert('请写评分说明')
          return false
        }
      })
    }
  }
}
</script>

<style>
.hiddenRow .el-table__cell:nth-child(n+2){
   overflow: hidden !important;
}
.box {
  display: flex;
  align-items: center;
}
.rate-box {
  width: 150px;
  /* margin-top:-15px; */
}
.form-item-box {
  flex: 1;
  margin-left: 50px;
  /* flex: 1; */
  /* height: 0px; */
}
.el-form-item {
  margin-bottom: 20px;
}
.top{
    height: 80px;
    line-height: 80px;
    /* width: 460px; */
    text-align: center;
    color: #fff;
    background-image: -webkit-linear-gradient(left, #4a86e8, #a960d9);
    position: relative;
}
.top img{
    position:absolute;
    left:5px;
    top:10px;
    vertical-align: middle;
}
</style>
